import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-white flex items-center justify-center">
          <div className="text-center px-6">
            <h1 className="text-4xl font-serif font-bold text-navy mb-4">
              Възникна грешка / An error occurred
            </h1>
            <p className="text-slate mb-8">
              Моля, опреснете страницата. / Please refresh the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-gold text-navy px-8 py-4 font-semibold uppercase tracking-wide hover:bg-yellow-500 transition-all duration-300"
            >
              Опресняване / Refresh
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
